import { datadogRum } from '@datadog/browser-rum';
import { EventType } from '@/lib/types';
import usePublicSearchContext from '@/publicSearch/store/usePublicSearchContext';

export function useDatadogTracker() {
  const society = usePublicSearchContext((s) => s.society);

  const trackEvent = (
    name: string,
    properties: Record<string, unknown> = {},
    eventType: EventType = EventType.BUTTON_CLICK,
  ) => {
    datadogRum.addAction(name, {
      ...properties,
      eventType,
      societyCode: society?.societyCode,
      societyId: society?.societyId,
      orgId: society?.orgId,
    });
  };

  return { trackEvent };
}
